import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const fetchAllCustomers = async (pagination: any) => {
  const { current, limit } = pagination;
  const skip = current * limit - limit;
  const result = await fetch(
    `${REACT_APP_ARPS_BASE_URL}/customers?skip=${skip}&limit=${limit}`
  );
  const contacts = await result.json();
  return contacts;
};

export default fetchAllCustomers;
